export default {"src":"/_next/static/media/logo-yogiyo.4d8c4653.svg","height":120,"width":93,"blurWidth":0,"blurHeight":0};